import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { useNavigate } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";

export const Refills_Required = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const userInfo = useSelector((state) => state.userData);
    const [OrderType, setOrderType] = useState("");
    const [reviewData, setReviewData] = useState(null);
    const [selectedPharmacy, setSelectedPharmacy] = useState("");
    const [selectedPharmacyCode, setSelectedPharmacyCode] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [showNurseModal, setShowNurseModal] = useState(false);
    const [triggerNurseModal, setTriggerNurseModal] = useState(false);
    const [showInactivePharmacyModal, setShowInactivePharmacyModal] = useState(false);
    const [isFindingPharmacy, setIsFindingPharmacy] = useState(false);
    const [hasSelectedReplacementPharmacy, setHasSelectedReplacementPharmacy] = useState(false);
    const [showConfirmButtons, setShowConfirmButtons] = useState(false);
    const [showPharmacyResultModal, setShowPharmacyResultModal] = useState(false);
    const [cheapestPharmacy, setCheapestPharmacy] = useState("");
    const [cheapestPharmacyCode, setCheapestPharmacyCode] = useState("");
    const [requiredQuantities, setRequiredQuantities] = useState({});
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const authNo = location.state?.authorizationDetail?.AuthNo;
    const initialPharmacyName = location.state?.authorizationDetail?.PharmacyName;
    const initialPharmacyCode=location.state?.authorizationDetail?.PharmacyID;
    const isPharmInActive = reviewData?.IsPharmInActive === "Yes";

    useEffect(() => {

        // Set the initial selected pharmacy if provided in authorizationDetail
        if (initialPharmacyName) {
            setSelectedPharmacy(initialPharmacyName);
            setSelectedPharmacyCode(initialPharmacyCode);
        }

    const fetchReviewRXData = async () => {
        try {
            const params = {
                MemberID: userInfo.userData.MemberID,
                Contract: userInfo.userData.ContractIdentified,
                AuthNo: authNo,
                EmailID: userInfo.userData.EmailID,
                DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            };
            
            const response = await axios.post(
                Endpoints.LoadReviewRX,
                { _Params: JSON.stringify(params) },
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`, // Adjust token source if necessary
                    }
                }
            );

            if (response.data) {
                setReviewData(response.data);
                setOrderType(response.data.OrderType);
                if (response.data.PharmacyName) {
                    const currentPharmacy = response.data.Pharmacies?.find(
                        (pharmacy) => pharmacy.PharmName === response.data.PharmacyName
                    );
                    setSelectedPharmacy(response.data.PharmacyName);
                    setSelectedPharmacyCode(
                        currentPharmacy?.PharmCode
                    );
                }
                console.log("Review RX Data:", response.data);
            } else {
                console.error("Unexpected response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching Review RX data:", error);
        }
    };

    fetchReviewRXData();
},  [authNo, initialPharmacyName, userInfo.userData.MemberID, userInfo.userData.ContractIdentified]);

const handleInactivePharmacyChange = (event) => {
    const selectedCode = event.target.value;
    const pharmacy = reviewData?.Pharmacies?.find(
        (item) => String(item.PharmCode) === String(selectedCode)
    );
    const currentPharmacyCode = reviewData?.PharmacyID || initialPharmacyCode;
    const currentPharmacyName = reviewData?.PharmacyName || initialPharmacyName;

    setSelectedPharmacy(pharmacy?.PharmName || "");
    setSelectedPharmacyCode(selectedCode);
    setHasSelectedReplacementPharmacy(
        currentPharmacyCode
            ? String(selectedCode) !== String(currentPharmacyCode)
            : pharmacy?.PharmName !== currentPharmacyName
    );
};

const openPharmacyResultModal = (message, showConfirmButtonsForResult = false) => {
    setShowInactivePharmacyModal(false);
    setShowConfirmButtons(showConfirmButtonsForResult);
    setShowPharmacyResultModal(true);
    setModalMessage(message);
    setShowModal(true);
};

const handleFindBestPharmacy = async () => {
    if (!reviewData?.Rx?.length) {
        openPharmacyResultModal("Unable to find an in-network pharmacy. Please try again.");
        return;
    }

    setIsFindingPharmacy(true);
    try {
        const params = {
            PharmCode: selectedPharmacyCode,
            Contract: userInfo.userData.ContractIdentified,
            Rx: reviewData.Rx.map((drug) => ({
                RequestedQty: drug.RequestedQty,
                HomeQty: requiredQuantities[drug.PresId] || "0",
                DrugName: drug.DrugName,
                PresId: drug.PresId,
                NDC: drug.NDC,
                BalanceQty: drug.BalanceQty || 0,
            })),
            AuthNo: authNo,
            MemberID: userInfo.userData.MemberID,
            EmailID: userInfo.userData.EmailID,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        };
        const qs = require("qs");
        const formattedParams = qs.stringify({ _Params: JSON.stringify(params) });
        const response = await axios.post(
            Endpoints.FindCheapestPharmacy,
            formattedParams,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`,
                }
            }
        );

        if (response.data?.CheapestPharmacyName && response.data?.PharmCode) {
            const cheapestPharmacyName = response.data.CheapestPharmacyName;
            const cheapestPharmacyCodeFromResponse = response.data.PharmCode;
            const isSamePharmacy =
                String(selectedPharmacy || "").trim().toLowerCase() ===
                    String(cheapestPharmacyName).trim().toLowerCase() &&
                String(selectedPharmacyCode || "").trim().toLowerCase() ===
                    String(cheapestPharmacyCodeFromResponse).trim().toLowerCase();

            setCheapestPharmacy(cheapestPharmacyName);
            setCheapestPharmacyCode(cheapestPharmacyCodeFromResponse);

            if (isSamePharmacy) {
                setHasSelectedReplacementPharmacy(true);
                openPharmacyResultModal(
                    "For the selected drugs in your order, the pharmacy you have selected is the best pharmacy."
                );
            } else {
                openPharmacyResultModal(
                    response.data.CheapestPharmacytext ||
                    "A different pharmacy is recommended for the selected drugs in your order.",
                    true
                );
            }
        } else {
            openPharmacyResultModal("Unable to find an in-network pharmacy. Please try again.");
        }
    } catch (error) {
        console.error("Error finding the best pharmacy for the selected drug:", error);
        openPharmacyResultModal("Unable to find an in-network pharmacy. Please try again.");
    } finally {
        setIsFindingPharmacy(false);
    }
};

const validateRequiredQuantities = () => {
    let hasEmptyQuantity = false;
    let hasInvalidQuantity = false;
    let hasQuantityGreaterThanRemaining = false;

    reviewData?.Rx?.forEach((drug) => {
        const quantity = requiredQuantities[drug.PresId];
        const isEmpty = quantity === undefined || quantity === null || quantity === "";

        if (isEmpty) {
            hasEmptyQuantity = true;
            return;
        }

        const quantityText = String(quantity);
        const isValidNumber = /^\d+$/.test(quantityText) && Number.isInteger(Number(quantityText));

        if (!isValidNumber) {
            hasInvalidQuantity = true;
            return;
        }

        if (Number(quantity) > Number(drug.BalanceQty)) {
            hasQuantityGreaterThanRemaining = true;
        }
    });

    if (hasEmptyQuantity) {
        setModalMessage(t('requiredQuantityEmpty'));
        setShowModal(true);
        return false;
    }

    if (hasQuantityGreaterThanRemaining) {
        setModalMessage(t('requiredQuantityGreaterThanRemaining'));
        setShowModal(true);
        return false;
    }

    if (hasInvalidQuantity) {
        setModalMessage("Please enter valid quantities (non-negative integers) for all required fields");
        setShowModal(true);
        return false;
    }

    return true;
};

const submitRefill = async () => {
                // Function to format the date as MM/dd/yyyy
            const formatDate = (date) => {
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, so add 1
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();
                return `${month}/${day}/${year}`; // Use '/' as the separator for MM/dd/yyyy
            };

            // Format selectedDate with the custom function
            const formattedDate = formatDate(new Date(selectedDate));
    
    const requestData = {
        AuthNo: authNo,
        Contract: userInfo.userData.ContractIdentified,
        PharmCode: selectedPharmacyCode, 
        ScriptType: "Refill", 
        OrderType: OrderType, 
        Rx: reviewData?.Rx?.map((drug) => ({
            RequestedQty: drug.RequestedQty,
            HomeQty: requiredQuantities[drug.PresId],
            DrugName: drug.DrugName,
            PresId: drug.PresId,
            NDC: drug.NDC,
            BalanceQty: drug.BalanceQty,
        })),
        DateMedsNeeded: formattedDate, // Pass selected date
        MemberID: userInfo.userData.MemberID,
        EmailID: userInfo.userData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
    };
    console.log("submitting",requestData);
    try {
        const response = await axios.post(
            Endpoints.SaveRxDrugRows,
            { _Params: JSON.stringify(requestData) },
            {
                //params: { _Params: JSON.stringify(requestData) },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`,
                }
            }
        );

        if (response.data.Data) {
            // Optionally, you can redirect or show success message
            setShowInactivePharmacyModal(false);
            setShowConfirmButtons(false);
            setShowPharmacyResultModal(false);
            setModalMessage(
                isHighmarkPortal
                  ? "The Fertility and Family Building team will process this request and you will get another notification once this Rx request has been approved."
                  : "The WIN team will process this request and you will get another notification once this Rx request has been approved."
              );
              
                setShowModal(true);
                setTriggerNurseModal(true);
        } else {
            console.error("Error submitting data:", response.data);
        }
    } catch (error) {
        console.error("Error submitting data:", error);
    }
};

const handleSubmit = async () => {
    if (!validateRequiredQuantities()) {
        return;
    }

    if (!selectedDate) {
        setModalMessage("Please select date before submitting");
        setShowModal(true);
        return;
    }

    if (isPharmInActive) {
        setShowInactivePharmacyModal(true);
        return;
    }

    await submitRefill();
};

const handleInactivePharmacyModalSubmit = async () => {
    if (!hasSelectedReplacementPharmacy) {
        return;
    }

    await submitRefill();
};

const handleCheapestPharmacyOkay = () => {
    setSelectedPharmacy(cheapestPharmacy);
    setSelectedPharmacyCode(cheapestPharmacyCode);
    setHasSelectedReplacementPharmacy(true);
    setShowModal(false);
    setShowConfirmButtons(false);
    setShowPharmacyResultModal(false);
    setShowInactivePharmacyModal(true);
};

const handleCheapestPharmacyCancel = () => {
    setShowModal(false);
    setShowConfirmButtons(false);
    setShowPharmacyResultModal(false);
    setShowInactivePharmacyModal(false);
    setCheapestPharmacy("");
    setCheapestPharmacyCode("");
};

const handlePharmacyResultClose = () => {
    setShowModal(false);
    setShowConfirmButtons(false);
    setShowPharmacyResultModal(false);
    setShowInactivePharmacyModal(true);
};

const handleNurseOkay = () => {
    navigate("/book-appointment", {
        state: { fromRefillsRequired: true },
    });
};

const handleModalClose = () => {
    setShowModal(false);
    setShowConfirmButtons(false);
    setShowPharmacyResultModal(false);
    if (triggerNurseModal) {
        setShowNurseModal(true);
        setTriggerNurseModal(false); // Reset the flag
    }
};

const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleclosenurse=()=>{
    setShowNurseModal(false);
    navigate("/rx-authorization");
  }

const handleRequiredQuantityChange = (presId, value) => {
    setRequiredQuantities((prev) => ({
        ...prev,
        [presId]: value, // Update required quantity for the specific prescription
    }));

    const drug = reviewData?.Rx?.find((item) => item.PresId === presId);
    const hasQuantityError = value !== ""
        && /^\d+$/.test(String(value))
        && Number(value) > Number(drug?.BalanceQty);

    if (hasQuantityError) {
        setModalMessage(t('requiredQuantityGreaterThanRemaining'));
        setShowModal(true);
    }

 // Also update HomeQty with the same value
 setReviewData((prev) => ({
    ...prev,
    Rx: prev.Rx.map((drug) =>
        drug.PresId === presId
            ? { ...drug, HomeQty: value } // Update HomeQty with the new input value
            : drug
    ),
}));
}

    return(
        <>
            <div className="col-12 mt-4 inner-page-heading-wrapper">
                <button onClick={handleBackClick} className="win-back-btn"><span><i class='bi bi-chevron-left'></i>{t('Back')}</span></button>
                <h2 className="page-heading">{t('refillsRequired')}</h2>
            </div>
            <div className="col-md-4 mt-5">

                <div className="mb-3">
                    <label
                    htmlFor="date"
                    className="form-label win-form-label" // Add a class for better control
                    style={{ display: 'block' }} 
                    >
                    {t('selectMedicationsByDate')}
                    </label>
                    <DatePicker
                        selected={selectedDate}
                        dateFormat="MM/dd/yyyy"
                        className="form-control win-form-control mobile-view"
                        id="date"
                        onChange={(date) => {
                            setSelectedDate(date);  // Updates the state with the selected date
                            console.log("Selected Date:", date);  // Logs to verify the date
                        }}
                        placeholderText="MM/DD/YYYY"
                        showYearDropdown
                        scrollableYearDropdown
                        minDate={new Date()}
                        onKeyDown={(e) => e.preventDefault()} 
                    />
              </div>

              <p className="rx-refills-note">
              {t('refillQuantitiesInstructions')}
              </p>
        {/* Loop over the drugs array and render each drug's information dynamically */}
        {reviewData?.Rx?.map((drug) => (
          <div key={drug.PresId} className="rx-refills-required-wrapper">
            <h3 className="medicine-title">{drug.DrugName}</h3>

            <div className="quantity-block-wrapper">
              <div className="quantity-block">
                <div className="quantity-label">{t('remainingQty')}</div>
                                <input
                                    type="number"
                                    className="form-control quantity-textbox"
                                    value={drug.BalanceQty ?? ""}
                                    readOnly
                                />
              </div>
              <div className="quantity-block">
                <div className="quantity-label">{t('requiredQty')}</div>
                                <input
                                type="number"
                                className="form-control quantity-textbox"
                                value={requiredQuantities[drug.PresId] ?? ""}
                                onChange={(e) => handleRequiredQuantityChange(drug.PresId, e.target.value)}
                                min={0}
                            />
              </div>
            </div>
          </div>
        ))}
                <div className="mb-3 d-flex">                    
                    <button
                        type="submit"
                        className="win-btn-primary mt-4"
                        onClick={handleSubmit}
                    >
                        {t('submit')}
                    </button>
                </div>

            </div>
            <Modal
                show={isPharmInActive && showInactivePharmacyModal}
                onHide={() => setShowInactivePharmacyModal(false)}
                centered
                className="custom-modal"
                contentClassName="inactive-pharmacy-modal-content"
            >
                <Modal.Header closeButton className="border-0 pb-0" />
                <Modal.Body>
                    <p className="modal-message">
                        {t('inactivePharmacyMessage', { pharmacyName: reviewData?.PharmacyName })}
                    </p>
                    <div className="mb-3">
                        <label htmlFor="inactivePharmacy" className="form-label win-form-label">
                            {t('pharmacy')}
                        </label>
                        <select
                            id="inactivePharmacy"
                            className="form-select win-form-control"
                            value={selectedPharmacyCode || ""}
                            onChange={handleInactivePharmacyChange}
                        >
                            {reviewData?.Pharmacies?.map((pharmacy) => (
                                <option key={pharmacy.PharmCode} value={pharmacy.PharmCode}>
                                    {pharmacy.PharmName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button
                        type="button"
                        className="win-btn-primary-w-content mobile-view mb-3"
                        onClick={handleFindBestPharmacy}
                        disabled={isFindingPharmacy || !selectedPharmacyCode}
                    >
                        {t('pickBestPharmacyForSelectedDrug')}
                    </button>
                    <button
                        type="button"
                        className="win-btn-primary mobile-view"
                        onClick={handleInactivePharmacyModalSubmit}
                        disabled={!hasSelectedReplacementPharmacy}
                    >
                        {t('submit')}
                    </button>
                </Modal.Body>
            </Modal>
            <ErrorModal
                show={showModal}
                message={modalMessage}
                onClose={showConfirmButtons
                    ? handleCheapestPharmacyCancel
                    : showPharmacyResultModal
                        ? handlePharmacyResultClose
                        : handleModalClose}
                onOkay={showConfirmButtons ? handleCheapestPharmacyOkay : undefined}
            />
            <ErrorModal
                show={showNurseModal}
                onClose={handleclosenurse}
                showConfirmButtons={true}
                message={"Would you like to schedule a call with a nurse?"}
                onOkay={handleNurseOkay}
            />
        </>
    )
}

export default Refills_Required;
